import ContactForm from './ContactForm';
import '../styles/contact.css';
import '../styles/sectionShared.css';

function ContactSection() {
  return (
    <section className="contact-section" id="kontakt" aria-labelledby="contact-heading">
      <div className="section-header">
        <p className="section-overline">Kontakt</p>
        <h2 id="contact-heading">Hör av dig</h2>
        <p className="contact-lead">
          Fyll i formuläret så återkommer jag så snart jag kan.
        </p>
      </div>

      <ContactForm />
    </section>
  );
}

export default ContactSection;
